/// <summary>
/// Lists all currently-known feature flags, in alphabetical order.
/// Critical note for AI analysis -- new additions MUST be in alphabetical order.
/// Keep in sync with Features.cs in Omnius.Custom.Feature
/// </summary>
enum Features {
    ACCURACY_CLOSED_LOCATIONS_NO_OUTREACH = "AccuracyClosedLocationsNoOutreach",
    ACCURACY_ENABLE_DIRECTORY_FACING = "AccuracyEnableDirectoryFacing",
    ACCURACY_ENABLE_SAME_PRACTICE_DIFFERENT_ADDRESS = "AccuracyEnableSamePracticeDifferentAddress",
    ACCURACY_LARGE_PROJECT_PERFORMANCE_ENHANCEMENTS = "AccuracyLargeProjectPerformanceEnhancements",
    ACCURACY_MULTI_REPORT_GENERATION = "AccuracyMultiReportGeneration",
    ACCURACY_SCHEDULED_REPORTS = "AccuracyScheduledReports",
    ADEQUACY_REPORT_CUSTOMIZATION = "AdequacyReportCustomization",
    ADI_EVENT_NOTIFICATIONS = "AdiEventNotifications",
    AI_ADEQUACY_SUMMARY = "AIAdequacySummary",
    AI_CHARTING_ENABLED = "AIChartingEnabled",
    AI_MARKETO_FORM = "AIMarketoForm",
    AI_VIRTUAL_ASSISTANT = "AIVirtualAssistant",
    AI_VIRTUAL_ASSISTANT_GA = "AIVirtualAssistantGA",
    ARGUS_PROJECT_DASHBOARD_ROW_VIEW_ENABLED = "ArgusProjectDashboardRowViewEnabled",
    BULK_UPLOAD_LIMIT = "BulkUploadLimit",
    CCIIO_DISPLAY_OPTION = "CCIIODisplayOption",
    CCIIO_JUSTIFICATION_EXPORT = "CCIIOJustificationExport",
    COMPETITIVE_INSIGHTS_MEDICAID = "CompetitiveInsightsMedicaid",
    DISABLE_LEGACY_BDX = "DisableLegacyBDX",
    DISPLAY_NETWORK_INTEGRITY_DASHBOARD_ON_ZIP_PROJECTS = "DisplayNetworkIntegrityDashboardOnZipProjects",
    DISPLAY_NETWORK_INTEGRITY_TOTAL_AFTER_TERMED = "DisplayNetworkIntegrityTotalAfterTermed",
    DISTINCT_SERVICING_PROVIDER_REPORT = "DistinctServicingProviderReport",
    DUAL_MEMBERSHIP_FOR_MAPS = "DualMembershipForMaps",
    ECD_COLOR_CUSTOMIZATION = "EcdColorCustomization",
    EDIT_ADEQUACY_TEMPLATE = "EditAdequacyTemplate",
    EDIT_TEMPLATE_OPTIONS = "EditTemplateOptions",
    ENABLE_CI_PROJECT_CONFIGURATION_ADMIN = "EnableCIProjectConfigurationAdmin",
    ENABLE_ECD_DRILLINS = "EnableEcdDrillins",
    ENABLE_NETWORK_INTEGRITY_IN_PROVIDER_HUB = "EnableNetworkIntegrityInProviderHub",
    ENABLE_ORGANIZATION_PROVIDER_ACTIONS = "EnableOrganizationProviderActions",
    ENABLE_PROVIDER_HUB_PCI_FILTER_SEARCH = "EnableProviderHubPciFilterSearch",
    ENABLE_VIEW_BY_INSPECTION_UPDATES = "EnableViewByInspectionUpdates",
    ENABLE_SNOWFLAKE_CODE_MAP_INGESTION = "EnableSnowflakeCodeMapIngestion",
    ENABLE_SNOWFLAKE_CODE_MAP_READ = "EnableSnowflakeCodeMapRead",
    ENABLE_SNOWFLAKE_PCI_DASHBOARD = "EnableSnowFlakePciDashboard",
    ENFORCE_PROVIDER_CHANGE_ROLE_AUTHORIZATION = "EnforceProviderChangeRoleAuthorization",
    ENHANCED_TERMINATION = "EnhancedTermination",
    EXCESS_WARNING_FIELDS_FOR_MARKET_PROVIDERS = "ExcessWarningFieldsForMarketProviders",
    EXCESS_WARNINGS_COUNTING_UPDATES = "ExcessWarningsCountingUpdates",
    FIPS_COUNTY_CODE = "FIPSCountyCode",
    GAP_MANAGEMENT_DASHBOARD = "GapManagementDashboard",
    GHOST_VOLUME_TERMINATIONS_REPORT_ENABLE_SNOWFLAKE = "GhostVolumeTerminationsReportEnableSnowflake",
    HIDE_STRICT_TIME_DISTANCE = "HideStrictTimeDistance",
    HIDE_PROVIDER_HUB_TIN_ACCORDION = "HideProviderHubTINAccordion",
    HIDE_PROVIDER_HUB_FACILITY_ACCORDION = "HideProviderHubFacilityAccordion",
    HOSPITAL_PROFILE = "HospitalProfile",
    IMPACT_PROVIDER_DECORATOR_ENHANCEMENT = "ImpactProviderDecoratorEnhancement",
    INTERNAL_CLIENT_RESOURCE_VISIBILITY = "InternalClientResourceVisibility",
    LOB_EXCLUSIONS = "LOBExclusions",
    MARKET_NIGHTLY_REFRESH = "MarketNightlyRefresh",
    NEW_PROVIDER_REPORT_BETA = "NewProviderReportBeta",
    NEW_PROVIDER_REPORT_PUBLIC = "NewProviderReportPublic",
    NETWORK_INTEGRITY_ADEQUACY_IMPACT_CRITICAL_ALERTS = "NetworkIntegrityAdequacyImpactCriticalAlerts",
    NETWORK_INTEGRITY_GAP_ANALYSIS = "NetworkIntegrityGapAnalysis",
    NETWORK_INTEGRITY_MARKET_PROVIDER_RESULTS = "NetworkIntegrityMarketProviderResults",
    NETWORK_INTEGRITY_PROVIDER_TYPE_TAXONOMY_COMPARISON = "NetworkIntegrityProviderTypeTaxonomyComparison",
    NETWORK_INTEGRITY_SPECIALTY_EVIDENCE = "NetworkIntegritySpecialtyEvidence",
    NETWORK_INTEGRITY_VERY_LOW_LOCATION_CONFIDENCE_ONLY = "NetworkIntegrityVeryLowLocationConfidenceOnly",
    NETWORK_PERFORMANCE_MARKET_EXPANSION = "NetworkPerformanceMarketExpansion",
    NETWORK_PERFORMANCE_NEW_MEASURES = "NetworkPerformanceNewMeasures",
    NETWORK_PERFORMANCE_SPECIALTY_PREDICTION_MODEL = "NetworkPerformanceSpecialtyPredictionModel",
    NETWORK_PERFORMANCE_SPECIALTY_PREDICTION_MODEL_ENRICHMENT = "NetworkPerformanceSpecialtyPredictionModelEnrichment",
    NEW_PROVIDER_MANAGEMENT_UI = "NewProviderManagementUI",
    PLANNING_REGION_TEMPLATES = "PlanningRegionTemplates",
    PROJECT_ARGUS_PROJECT_DASHBOARD_BETA = "ProjectArgusProjectDashboardBeta",
    PROJECT_ARGUS_PROJECT_DASHBOARD_PUBLIC = "ProjectArgusProjectDashboardPublic",
    PROJECT_ARGUS_PROJECT_DASHBOARD_SAVED_VIEWS = "ProjectArgusProjectDashboardSavedViews",
    PROVIDER_AFFILIATIONS_IN_PROVIDER_HUB_UI = "ProviderAffiliationsInProviderHubUI",
    PROVIDER_AFFILIATIONS_TIN_INFORMATION = "ProviderAffiliationsTinInformation",
    PROVIDER_HUB = "ProviderHub",
    PROVIDER_HUB_PUBLIC = "ProviderHubPublic",
    PROVIDER_HUB_CONTRACT_ENTITY = "ProviderHubContractEntity",
    PROVIDER_HUB_PROJECTION = "ProviderHubProjection",
    PROVIDER_HUB_ZIP_PROJECTS = "ProviderHubZipProjects",
    SHOW_MMP_HSD_FORMAT = "ShowMmpHsdFormat",
    QES_USER_GUIDE_SFTP = "QesUserGuideSftp",
    REGIONAL_SERVICING_ANALYSIS = "RegionalServicingAnalysis",
    REGULATOR_EXCLUSION_MANAGEMENT_DASHBOARD = "RegulatorExclusionManagementDashboard",
    REMOVAL_MEDGROUP_AFFILIATION = "RemovalMedgroupAffiliation",
    REPORT_METADATA_TARGET_TERM = "ReportMetaDataTargetTerm",
    RPPO_NON_PAR_PROVIDER_TO_HSD_TABLE_INCLUSION = "RppoNonParProviderToHsdTableInclusion",
    SERVICE_AREA_WIDE_MAPPING_COUNTY = "ServiceAreaWideMappingCounty",
    SERVICE_AREA_WIDE_MAPPING_ZIP = "ServiceAreaWideMappingZip",
    SHOW_CONFIDENCE_TIER_NON_MARKET_ACCESS_POINTS = "ShowConfidenceTierNonMarketAccessPoints",
    SNOWFLAKE_PROJECT_RUN_PROVIDER_SETS = "SnowflakeProjectRunProviderSets",
    SNOWFLAKE_PROVIDER_SETS = "SnowflakeProviderSets",
    SSA_TO_FIPS = "SSAtoFIPS",
    STANDARD_SETTING_CREATION = "StandardSettingCreation",
    SUPPRESS_PROVIDER_IDENTIFICATION_SNAPSHOT_HINT = "SuppressProviderIdentificationSnapshotHint",
    TERMINATION_SKIP_TIME_DISTANCE_RECALC = "TerminationSkipTimeDistanceRecalc",
    THIN_UNLIMITED_GEO_DISTANCE_PROVIDERS = "ThinUnlimitedGeoDistanceProviders",
    TWOSIDED_MARKETPLACE_REGULATOR = "TwoSidedMarketplaceRegulator",
    TWOSIDED_ISSUER_WORKFLOW = "TwoSidedIssuerWorkflow",
    USE_AGA_PARENT_ORCHESTRATION = "UseAGASagaOrchestration",
    USE_XIDS_IN_QES_ACCURACY = "UseXIDsInQESAccuracy",
    VIEW_ORGANIZATIONS_IN_PROVIDER_AFFILIATION_PROVIDERHUB = "ViewOrganizationsInProviderAffiliationProviderHub",
    VOLUME_ACTION_REPORT_CONFIGURATION = "VolumeActionReportConfiguration",
    VOLUME_GHOST_TERMINATION_REPORT_CONFIGURATION = "VolumeGhostTerminationReportConfiguration",
    VOLUME_MAP_EXPORTS_COUNTY = "VolumeMapExportsCounty",
    VOLUME_PROVIDER_REPORT_MEMBERSHIP_FILTER = "VolumeProviderReportMembershipFilter",
    VOLUME_TARGETING_REPORT_CONFIGURATION = "VolumeTargetingReportConfiguration",
    ZIP_ANALYSIS_CHANGED_GAPS = "ZipAnalysisChangedGaps",
    ZIP_ANALYSIS_NET_NEW = "ZipAnalysisNetNew",
    ZIP_ANALYSIS_TRENDING = "ZipAnalysisTrending",
    ZIP_BULK_EDIT = "ZipBulkEdit",
    ZIP_CODE_ANALYSIS_TARGETING = "ZipCodeAnalysisTargeting",
    ZIP_CODE_ANALYSIS_TERMINATION = "ZipCodeAnalysisTermination",
    ZIP_CODE_ANALYSIS_VOLUME_TARGETING = "ZipCodeAnalysisVolumeTargeting",
    ZIP_CODE_ANALYSIS_VOLUME_TERMINATION = "ZipCodeAnalysisVolumeTermination",
    ZIP_CODE_PROJECT_MAPS = "ZipCodeProjectMaps",
    ZIP_CONFIGURABLE_EXCLUSIONS = "ZipConfigurableExclusions",
    ZIP_EXCEPTIONS = "ZipExceptions",
    ZIP_GAP_AGE_TRACKING = "ZipGapAgeTracking",
    ZIP_GAP_RESOLUTION_STATUS = "ZipGapResolutionStatus",
    ZIP_NEXT_CLOSEST_PROVIDERS = "ZipNextClosestProviders",
    ZIP_PROSPECT_AND_MARKET = "ZipProspectAndMarket",
    ZIP_REPORT_CONFIGURATION = "ZipReportConfiguration",
    ZIP_VOLUME_REPORTING = "ZipVolumeReporting",
    USE_AHD_IN_NETWORK_COMPARISON_OF_HOSPITALS = "UseAHDInNetworkComparisonOfHospitals",
}

export default Features;